import React from 'react';
import styled from 'styled-components';
import SpinnerYellowIcon from 'assets/svg/SpinnerYellowIcon';

const StyledLoader = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
});

const Loader = () => (
  <StyledLoader data-testid="loader">
    <SpinnerYellowIcon />
  </StyledLoader>
);

export default Loader;
